<template>
  <div class="container">
    <Nav></Nav>
    <div class="breadcrumb_center">
      <el-breadcrumb
        class="el-breadcrumb__inner"
        separator-class="el-icon-arrow-right"
      >
        <img src="../assets/qingye/indexImg.png" alt="" />
        <div>
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item
            :to="{ path: '/ParkKeeper' }"
            class="ToParkKeeper"
          >
            案例展示
          </el-breadcrumb-item>
          <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
        </div>
      </el-breadcrumb>
    </div>
    <div class="ProductCaseDetail index_center">
      <div class="ProductCaseDetail_rich" v-html="content"></div>
    </div>
    <SubmitFrom></SubmitFrom>
  </div>
</template>
<script>
import Nav from "./components/navBar";
import SubmitFrom from "./components/SubmitFrom";
import { getProductInfoApi } from "@/api/index";
export default {
  components: { Nav, SubmitFrom },
  data() {
    return {
      id: "",
      title: "",
      type: "",
      content: "",
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
    this.$cookies.set("tabbar", this.type);
    this.$store.state.tabbar = this.$cookies.get("tabbar");
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getProductInfo();
  },
  methods: {
    //获取产品详情
    getProductInfo() {
      var data = {
        id: this.id,
      };
      getProductInfoApi(data).then((res) => {
        this.title = res.data.title;
        this.content = res.data.content;
        this.$store.state.tabIndex = res.data.type;
      });
    },
  },
};
</script>
<style scoped>
.index_center {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  min-width: 1200px;
}
.ProductCaseDetail {
  /*max-width: 1360px;*/
  /*background: orange;*/
  width: 1200px;
  margin-top: 70px;
}
.ProductCaseDetail_rich {
  width: 85%;
  margin: 0 auto;
}
.ProductCaseDetail_rich /deep/ img {
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  display: block;
  margin: 12px 0;
}
.breadcrumb_center {
  background-color: #f6f7f8;
  display: flex;
  /*width: 1200px;*/
  justify-content: space-around;
  height: 50px;
  margin: 0 auto;
}
.el-breadcrumb__inner {
  display: flex;
  align-items: center;
  width: 1200px;
  color: #666666;
}
.el-breadcrumb__inner img {
  padding: 0 10px 0px 0;
}
div /deep/ .el-breadcrumb__inner.is-link {
  font-weight: normal;
  color: #606266;
}
.paddingBottom {
  padding-bottom: 35px;
  color: #82848a;
  border-bottom: 1px solid #82848a;
}

.ProductCaseDetail_text1 {
  text-align: center;
  font-size: 24px;
  color: #333333;
  padding-bottom: 64px;
}

.ProductCaseDetail_text2 {
  border-bottom: 1px solid #82848a;
}
.ProductCaseDetail_text2 div {
  font-size: 20px;
  color: #2968bd;
}
.ProductCaseDetail_text2 p {
  padding-top: 30px;
  font-size: 14px;
  color: #666666;
  text-indent: 2em;
  line-height: 25px;
}

.ProductCaseDetail_text3 div {
  color: #2968bd;
  padding: 20px 0;
  font-size: 20px;
}

.ProductCaseDetail_text3 p {
  text-indent: 2em;
  color: #666666;
  font-size: 14px;
  line-height: 25px;
}

.ProductCaseDetail_text4_txt {
  font-size: 20px;
  padding: 20px 0;
  color: #2968bd;
}

.ProductCaseDetail_text4 p {
  text-indent: 1em;
  font-size: 14px;
  padding-bottom: 5px;
  color: #666666;
  line-height: 25px;
}

.ProductCaseDetail_text5_flex {
  display: flex;
  /*flex-direction: column;*/
  justify-content: center;
  align-items: center;
}
.ProductCaseDetail_text5 div {
  color: #2968bd;
  font-size: 20px;
  padding: 20px 0;
}

.ProductCaseDetail_text5_img {
  flex-wrap: wrap;
  display: flex;
  justify-content: center;
  align-items: center;
  /*width: 36%;*/
  width: 520px;
  height: 300px;
}
.ProductCaseDetail_text5_img img {
  width: 100%;
  height: 100%;
}
/* .ProductCaseDetail_text5_img div {
  padding: 2px;
} */
.ProductCaseDetail_text6_txt {
  font-size: 20px;
  padding: 20px 0;
  color: #2968bd;
}
.ProductCaseDetail_text6 p {
  font-size: 14px;
  padding-bottom: 5px;
  text-indent: 1em;
  color: #666666;
  line-height: 25px;
}
.ProductCaseDetail_text7_txt {
  font-size: 20px;
  padding: 20px 0;
  color: #2968bd;
}
.ProductCaseDetail_text7 p {
  text-indent: 1em;
  padding-top: 10px;
  font-size: 14px;
  color: #666666;
  line-height: 25px;
}
.ToParkKeeper {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/ProductCaseDetail.vue